import "esbuild-css-modules-plugin-ns-css:src/js/pages/govEntityStep/govEntityStep.module.css";

import { inject } from "esbuild-css-modules-plugin-ns-js:src/js/pages/govEntityStep/govEntityStep.module.css:injector.js";
export default new Proxy({
  "contentContainer": "govEntityStep-module__contentContainer_ztV8cq__1100",
  "description": "govEntityStep-module__description_ztV8cq__1100",
  "headingAndTooltipContainer": "govEntityStep-module__headingAndTooltipContainer_ztV8cq__1100",
  "infoIcon": "govEntityStep-module__infoIcon_ztV8cq__1100",
  "mobileH2": "govEntityStep-module__mobileH2_ztV8cq__1100",
  "pageContainer": "govEntityStep-module__pageContainer_ztV8cq__1100",
  "selectText": "govEntityStep-module__selectText_ztV8cq__1100",
  "tooltipHeading": "govEntityStep-module__tooltipHeading_ztV8cq__1100"
}, {
  get: function(source, key) {
    inject();
    return source[key];
  }
});
      